import {http} from '../utils/http'
import {API_BASE_URL} from '../constants/appConstant'
import auth from '../utils/auth'

const token = () => {
  const value = auth.getToken()
  if (!value) throw new Error('未获取到 Anylink 登录凭证，Harness 不会发起请求')
  return value
}

const guarded = request => {
  try {
    token()
    return request()
  } catch (error) {
    return Promise.reject(error)
  }
}

const createSession = (workspaceId = 'default') => guarded(() => http.post('/api/ai/sessions', {workspaceId}))
const runtimeEntry = () => guarded(() => http.get('/harness/runtime-entry'))
const bootstrapEmbed = async () => {
  const authToken = token()
  const response = await fetch(`${API_BASE_URL}/harness/embed/bootstrap`, {
    method: 'POST',
    headers: {Authorization: `Bearer ${authToken}`, 'Auth-Type': 'ssofed', Accept: 'application/json'},
    credentials: 'include',
    cache: 'no-store',
  })
  // Older/legacy deployments do not expose this optional bootstrap endpoint.
  if (response.status === 404) return false
  if (!response.ok) throw new Error(`Harness 嵌入认证失败 (${response.status})`)
  return true
}
const sendMessage = (sessionId, message, mode = 'queue') => guarded(() => http.post(`/api/ai/sessions/${encodeURIComponent(sessionId)}/messages`, {message, mode}))
const approve = (sessionId, approval) => guarded(() => http.post(`/api/ai/sessions/${encodeURIComponent(sessionId)}/approvals`, approval))
const cancel = sessionId => guarded(() => http.post(`/api/ai/sessions/${encodeURIComponent(sessionId)}/cancel`, {}))

const streamEvents = async (sessionId, onEvent, signal) => {
  const authToken = token()
  const response = await fetch(`${API_BASE_URL}/api/ai/sessions/${encodeURIComponent(sessionId)}/events`, {
    headers: {Authorization: `Bearer ${authToken}`, 'Auth-Type': 'ssofed'},
    signal,
    credentials: 'omit',
  })
  if (!response.ok || !response.body) throw new Error(`Harness 事件流连接失败 (${response.status})`)
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  while (true) {
    const {done, value} = await reader.read()
    if (done) break
    buffer += decoder.decode(value, {stream: true})
    const chunks = buffer.split('\n\n')
    buffer = chunks.pop()
    chunks.forEach(chunk => {
      const line = chunk.split('\n').find(item => item.indexOf('data:') === 0)
      if (line) onEvent(JSON.parse(line.slice(5).trim()))
    })
  }
}

export default {runtimeEntry, bootstrapEmbed, createSession, sendMessage, streamEvents, approve, cancel}
